<template>
    <SoliText
        ref="phone"
        v-model="input"
        :disabled="disabled"
        :label="label ?? 'Phone'"
        :errors="errors"
        :rules="rules.phone"
        :hide-details="hideDetails"
        validateOnBlur
        phone
        icon="phone"
        placeholder="10-digits"
        @input="maskPhone"
    ></SoliText>
</template>

<script>
import SoliForm from "./SoliForm.vue";

export default {
    props: {
        errors: {},
        value: {},
        label: {},
        hideDetails: {
            type: [Boolean, String],
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            rules: SoliForm.formRules,
        };
    },
    methods: {
        maskPhone(value) {
            if (!value) return;
            let x = value
                .replace(/\D/g, "")
                .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);

            return !x[2] ? x[1] : x[1] + "-" + x[2] + (x[3] ? "-" + x[3] : "");
        },
    },
    mounted() {
        this.maskPhone(this.value);
    },
    computed: {
        input: {
            get() {
                return this.maskPhone(this.value);
            },
            set(value) {
                if (value?.length == 12)
                    this.$refs.phone.$refs.input.validate();
                this.$emit("input", value);
            },
        },
    },
};
</script>
